$(function() {
    $(document).on('click', '.prevent-default', function(eventObj) {
        eventObj.preventDefault();
    });
});